/* House of Mina — product page enhancements (Horizon theme)
   1. The nickel-free note, under the Plating Finish choice, once nickel-free is chosen
   2. An explicit size before Add to cart / Buy it now
   3. A buy bar fixed to the bottom of the screen on phones

   Horizon renders each variant option as:
     <variant-picker><form class="variant-picker__form">
       <fieldset class="variant-option variant-option--buttons">
         <legend>Plating</legend>
         <label class="variant-option__button-label"><input type="radio" value="…">…</label>
   The option fieldsets live inside <variant-picker>, NOT inside the
   form[action*="/cart/add"] (that's the separate buy-buttons form). The picker is
   re-rendered (morphed) after every change, so everything here re-applies from a
   MutationObserver and must leave the page alone when it is already right.

   The product page audit of 2026-09-24 reworked 1–3: the note shrank to one line with the
   rest behind "Why?"; the size gate no longer disables the buttons (a disabled button
   cannot say what is missing) — it labels Add to cart "Choose size", and a tap on either
   button brings the sizes into view instead; Buy it now keeps its place from the start. */
(function () {
  'use strict';

  var root = document.querySelector('.product-information') || document;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function legendText(fs) {
    var lg = fs.querySelector('legend');
    return lg ? (lg.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function picker() {
    return root.querySelector('variant-picker');
  }

  function optionFieldsets() {
    var p = picker();
    return p ? p.querySelectorAll('fieldset') : [];
  }

  /* ---------- 1. Nickel-free note ----------
     Nickel-free is offered two ways depending on how many options a product already
     uses (Shopify caps products at 3 options): extra "· Nickel-Free" values on the
     Plating option (drawn as a Plating Finish row by snippets/hom-plating-split.liquid),
     or a separate "Plating Finish" option. Either way there is a Plating Finish row. */
  /* The owner's full wording (2026-09-01), shown in full: the 09-24 audit had cut it to
     one line with the rest behind "Why?", and the owner wants it read before buying. */
  var NICKEL_NOTE =
    'Nickel-free plating is hypoallergenic \u2014 gentle on sensitive skin. ' +
    'Please note there is a significant difference in both shine and durability: ' +
    'our standard plating uses a nickel base layer that gives it noticeably ' +
    'brighter shine and a harder-wearing finish, so a nickel-free piece looks ' +
    'softer and will wear sooner.';

  function finishFieldset() {
    var fss = optionFieldsets();
    for (var i = 0; i < fss.length; i++) {
      if (/plating\s*finish/i.test(legendText(fss[i]))) return fss[i];
    }
    return null;
  }

  function nickelChosen() {
    var p = picker();
    if (!p) return false;
    var checked = p.querySelectorAll('input:checked');
    for (var i = 0; i < checked.length; i++) {
      if (/nickel[\s-]*free/i.test(checked[i].value || '')) return true;
    }
    return false;
  }

  function applyNickelNote() {
    var fs = finishFieldset();
    var existing = document.querySelector('.hom-nickel-note');
    if (!fs || !nickelChosen()) {
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.previousElementSibling === fs) return;
    if (existing) existing.remove();
    var note = document.createElement('p');
    note.className = 'hom-nickel-note';
    note.textContent = NICKEL_NOTE;
    fs.parentNode.insertBefore(note, fs.nextSibling);
  }

  /* ---------- 2. Require a size ---------- */
  var sizeChosen = false;
  var gateReady = false;

  function sizeFieldsets() {
    var out = [];
    var fss = optionFieldsets();
    for (var i = 0; i < fss.length; i++) {
      if (/\bsize\b/i.test(legendText(fss[i]))) out.push(fss[i]);
    }
    return out;
  }

  function gated() {
    return gateReady && !sizeChosen && sizeFieldsets().length > 0;
  }

  function buyBlock() {
    return root.querySelector('.buy-buttons-block');
  }

  function addButton() {
    return root.querySelector('product-form-component [ref="addToCartButton"], product-form-component button[name="add"]');
  }

  function ensureHint() {
    var p = picker();
    if (!p || !p.parentNode) return null;
    var hint = document.getElementById('hom-size-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.id = 'hom-size-hint';
      hint.className = 'hom-size-hint';
      hint.setAttribute('role', 'status');
      hint.hidden = true;
      p.parentNode.insertBefore(hint, p.nextSibling);
    }
    return hint;
  }

  /* A tap on Add to cart, Buy it now or the buy bar before a size is chosen. */
  function askForSize() {
    var groups = sizeFieldsets();
    var hint = ensureHint();
    if (hint) {
      hint.textContent = 'Choose your size to continue.';
      hint.hidden = false;
    }
    var fs = groups[0];
    if (!fs) return;
    fs.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    fs.classList.remove('hom-size-option--ask');
    void fs.offsetWidth; /* restart the highlight */
    fs.classList.add('hom-size-option--ask');
    var first = fs.querySelector('input:not([aria-disabled="true"])') || fs.querySelector('input');
    if (first) first.focus({ preventScroll: true });
  }

  function setLabel(button, text) {
    if (!button) return;
    var span = button.querySelector('.add-to-cart-text__content');
    if (!span) return;
    if (!span.hasAttribute('data-hom-label')) span.setAttribute('data-hom-label', span.textContent.trim());
    if (span.textContent !== text) span.textContent = text;
  }

  function restoreLabel(button) {
    var span = button && button.querySelector('.add-to-cart-text__content[data-hom-label]');
    if (!span) return;
    var text = span.getAttribute('data-hom-label');
    if (span.textContent !== text) span.textContent = text;
  }

  /* "From" the lowest price while no size is chosen, when some sizes cost more
     (snippets/variant-main-picker.liquid puts data-hom-from on the size row). */
  function applyFrom(on) {
    var price = root.querySelector('product-price .price');
    if (!price) return;
    var from = null;
    var groups = sizeFieldsets();
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].getAttribute('data-hom-from')) from = groups[i].getAttribute('data-hom-from');
    }
    var mark = price.parentNode.querySelector('.hom-from');
    if (on && from) {
      if (!mark) {
        mark = document.createElement('span');
        mark.className = 'hom-from';
        mark.textContent = 'From ';
        price.parentNode.insertBefore(mark, price);
      }
      if (price.textContent.trim() !== from) price.textContent = from;
    } else if (mark) {
      mark.remove();
    }
  }

  function refreshSizeGate() {
    if (!gateReady) return;
    var groups = sizeFieldsets();
    var block = buyBlock();
    var button = addButton();
    if (!groups.length) {
      if (block) block.classList.remove('hom-gated');
      return;
    }
    if (!sizeChosen) {
      /* The picker is re-rendered with a size ticked after any other change; the
         customer has not chosen one, so untick it again. */
      groups.forEach(function (fs) {
        fs.querySelectorAll('input:checked').forEach(function (inp) { inp.checked = false; });
      });
      if (block && !block.classList.contains('hom-gated')) block.classList.add('hom-gated');
      setLabel(button, 'Choose size');
      applyFrom(true);
    } else {
      if (block) block.classList.remove('hom-gated');
      restoreLabel(button);
      applyFrom(false);
      var hint = document.getElementById('hom-size-hint');
      if (hint && !hint.hidden) hint.hidden = true;
    }
  }

  function initSizeGate() {
    if (!sizeFieldsets().length) return; /* no size option — leave it alone */
    gateReady = true;
    refreshSizeGate();
  }

  /* On window, in the capture phase: ahead of the theme's delegated handlers (on
     document), Shopify's Buy it now, and the Birthstone Stack's own submit handler. */
  var BUY = 'button[name="add"], [ref="addToCartButton"], .shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout, shopify-buy-it-now-button, [ref="acceleratedCheckoutButtonContainer"]';
  window.addEventListener('click', function (e) {
    if (!gated() || !e.target || !e.target.closest) return;
    var hit = e.target.closest(BUY);
    if (!hit || !root.contains(hit)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    askForSize();
  }, true);
  window.addEventListener('submit', function (e) {
    if (!gated() || !e.target || !root.contains(e.target)) return;
    if (!e.target.closest('product-form-component')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    askForSize();
  }, true);

  /* ---------- 3. Buy bar (phones) ---------- */
  var bar = null;
  var barVisible = false;

  function priceText() {
    var stack = root.querySelector('.hom-bs-price'); /* Birthstone Stack: the whole stack's price */
    if (stack) {
      var amount = stack.querySelector('.hom-bs-price__amount'), note = stack.querySelector('.hom-bs-price__note');
      return (amount ? amount.textContent : '') + (note && note.textContent ? ' · ' + note.textContent.replace('for ', '') : '');
    }
    var summary = root.querySelector('[data-bs-summary]'); /* Birthstone Stack: bands and total */
    if (summary && /Rs/.test(summary.textContent) && /band/.test(summary.textContent) && !gated()) {
      return summary.textContent.split(' — ')[0].trim();
    }
    var price = root.querySelector('product-price [ref="priceContainer"] .price, product-price .price');
    if (!price) return '';
    var mark = price.parentNode.querySelector('.hom-from');
    return (mark ? 'From ' : '') + price.textContent.trim();
  }

  function buildBar() {
    if (bar || !addButton()) return;
    var title = root.querySelector('h1');
    bar = document.createElement('div');
    bar.className = 'hom-buybar';
    bar.setAttribute('aria-hidden', 'true');
    var info = document.createElement('div');
    info.className = 'hom-buybar__info';
    var t = document.createElement('span');
    t.className = 'hom-buybar__title';
    t.textContent = title ? title.textContent.trim() : '';
    var pr = document.createElement('span');
    pr.className = 'hom-buybar__price';
    info.appendChild(t);
    info.appendChild(pr);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hom-buybar__button';
    btn.tabIndex = -1;
    btn.addEventListener('click', function () {
      if (gated()) {
        askForSize();
        return;
      }
      var real = addButton();
      if (real && !real.disabled) real.click();
    });
    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    document.body.classList.add('hom-has-buybar');

    var target = buyBlock();
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        barVisible = !entries[0].isIntersecting;
        refreshBar();
      }).observe(target);
    }
    refreshBar();
  }

  function refreshBar() {
    if (!bar) return;
    var real = addButton();
    var btn = bar.querySelector('.hom-buybar__button');
    var price = bar.querySelector('.hom-buybar__price');
    var text = priceText();
    if (price.textContent !== text) price.textContent = text;
    /* The real button's own words ("Add to cart", "Sold out"), except while it waits for a size. */
    var own = real && real.querySelector('.add-to-cart-text__content');
    var label = gated() ? 'Choose size' : (own && own.textContent.trim()) || 'Add to cart';
    if (btn.textContent !== label) btn.textContent = label;
    var off = !gated() && !!(real && real.disabled);
    if (btn.disabled !== off) btn.disabled = off;
    var show = barVisible;
    if (bar.classList.contains('is-visible') !== show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
  }

  /* ---------- boot ---------- */
  function refreshAll() {
    applyNickelNote();
    refreshSizeGate();
    refreshBar();
  }

  function init() {
    initSizeGate();
    applyNickelNote();
    buildBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* A timer, not requestAnimationFrame: frames stop in a tab the browser is not painting. */
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      refreshAll();
    }, 0);
  }
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type=radio], input[type=checkbox], select')) return;
    var fs = t.closest('fieldset');
    if (fs && /\bsize\b/i.test(legendText(fs)) && t.checked) sizeChosen = true;
    queue();
  });
})();
